import { render, staticRenderFns } from "./Submitted.vue?vue&type=template&id=506cb91d"
import script from "./Submitted.vue?vue&type=script&lang=js"
export * from "./Submitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports